import { typographyStyles } from "@newsela/angelou";
const { heading4 } = typographyStyles;

export const contentHeaderCss = [
  {
    margin: "0",
  },
  heading4,
];

export const addIconCss = {
  width: "20px",
};

export const chevronLeftIconCss = {
  width: "20px",
};
